document.addEventListener('DOMContentLoaded', function () {
  var dropdowns = document.querySelectorAll('.nav-dropdown');
  dropdowns.forEach(function (dropdown) {
    var trigger = dropdown.querySelector('.nav-dropdown__trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = dropdown.classList.contains('is-open');
      dropdowns.forEach(function (d) { d.classList.remove('is-open'); d.querySelector('.nav-dropdown__trigger').setAttribute('aria-expanded', 'false'); });
      if (!isOpen) {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', function () {
    dropdowns.forEach(function (d) { d.classList.remove('is-open'); d.querySelector('.nav-dropdown__trigger').setAttribute('aria-expanded', 'false'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      dropdowns.forEach(function (d) { d.classList.remove('is-open'); d.querySelector('.nav-dropdown__trigger').setAttribute('aria-expanded', 'false'); });
    }
  });
});
